"use client";
import { IweatherMarine } from "@/interfaces/IweatherMarine";
import { getweatherMarine, searchTravel } from "@/services/backOffice";
import {
  Autocomplete,
  Box,
  CircularProgress,
  Divider,
  Skeleton,
  SxProps,
  Tab,
  Tabs,
  TextField,
  Theme,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Image from "next/image";
import HumidityIcon from "@mui/icons-material/OpacityRounded";
import WindIcon from "@mui/icons-material/Air";
import VisibilityIcon from "@mui/icons-material/VisibilityOutlined";
import GaugeIcon from "@mui/icons-material/Speed";

import ForcastWeather from "./ForcastWeather";
import "swiper/css";
import "swiper/css/navigation";

import { SearchContent } from "@/interfaces/SeachData";
import { throttle } from "lodash";

import SearchIcon from "@mui/icons-material/SearchRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import ArrowIcon from "@mui/icons-material/OutboundRounded";
import TideIcon from "@mui/icons-material/TsunamiRounded";
import ClockIcon from "@mui/icons-material/WatchLaterRounded";

// conver funtion
function extractDateOrTime(datetimeStr: string | undefined, part = "time"): string {
  if (!datetimeStr) return "";

  const parts = datetimeStr.split(" ");
  if (parts.length === 2) {
    return part.toLowerCase() === "date" ? parts[0] : parts[1];
  }
  return datetimeStr;
}

const getAbsoluteUrl = (url: string | undefined): string => {
  if (!url) return "";

  if (url.startsWith("//")) {
    return `https:${url}`;
  }
  return url;
};

const destinationList = [
  {
    name: "Alaska",
    url: "alaska",
    codinate: "59.05807010198063, -147.1175488892965",
  },
  {
    name: "Africa",
    url: "africa",
    codinate: "-9.0211135122352, 41.92036346364262",
  },
  {
    name: "Asia",
    url: "asia",
    codinate: "14.401155377901404, 115.1491955370512",
  },
  {
    name: "Antarctica",
    url: "antarctica",
    codinate: "-63.95213624468091, -50.90517493948662",
  },
  {
    name: "Arctic",
    url: "arctic",
    codinate: "75.76430268554228, -138.65085090569713",
  },
  {
    name: "Australasia",
    url: "australasia",
    codinate: "-36.410036442992734, 128.48095921719343",
  },
  {
    name: "Canada",
    url: "canada",
    codinate: "43.520668484069056, -62.357813862643034",
  },
  {
    name: "Caribbean",
    url: "caribbean",
    codinate: "14.882822136123762, -74.95143225358399",
  },
  {
    name: "Indian Ocean",
    url: "indian-ocean",
    codinate: "-20.847516486737256, 81.31659049797467",
  },
  {
    name: "Mediterranean",
    url: "mediterranean",
    codinate: "34.62678520231889, 18.392938869065212",
  },
  {
    name: "Middle East",
    url: "middle-east",
    codinate: "17.53467127255926, 63.00681315569125",
  },
  {
    name: "Mississippi",
    url: "mississippi",
    codinate: "30.308358868009346, -88.95326743206704",
  },
  {
    name: "Panama Canal",
    url: "panama-canal",
    codinate: "9.119953552278155, -79.73346655734748",
  },
  {
    name: "Pacific",
    url: "pacific",
    codinate: "12.46269457224932, -168.39975754209854",
  },
  {
    name: "Transatlantic",
    url: "transatlantic",
    codinate: "61.79316633701559, -92.06646969316243",
  },
  {
    name: "Western Europe",
    url: "western-europe",
    codinate: "48.24176625546021, -12.220370437427947",
  },
  {
    name: "World Wide",
    url: "world-wide",
    codinate: "",
  },
];

const WeatherComponent: React.FC<{
  sx?: SxProps<Theme>;
}> = ({ sx }) => {
  const [weatherData, setWeatherData] = useState<IweatherMarine | undefined>();
  const [forecastModalOpen, setForecastModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingS, setIsLoadingS] = useState(false);
  const [destinations, setDestinations] = useState<SearchContent[]>([]);
  const [cordinate, setCordinate] = useState<string>("");
  const [selectedDestination, setSelectedDestination] = useState<SearchContent | null>(null);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const pathSegments = window.location.pathname.split("/");
    const destinationUrl = pathSegments[pathSegments.length - 1];
    const matchedDestination = destinationList.find((x) => x.url === destinationUrl);

    if (matchedDestination) {
      setCordinate(matchedDestination.codinate);
      setInputValue(matchedDestination.name.toUpperCase());
    }
    setInputValue(destinationUrl.toUpperCase());
  }, []);

  const [destination, setDestination] = useState("");

  useEffect(() => {
    const pathSegments = window.location.pathname.split("/");
    const destinationUrl = pathSegments[pathSegments.length - 1];
    setDestination(destinationUrl);
  }, []);

  const q = selectedDestination?.name || cordinate || destination || "";

  useEffect(() => {
    if (q) {
      const days = 7;
      const fetchWeatherData = async () => {
        try {
          setIsLoading(true);
          const { data } = await getweatherMarine(q, days);
          setWeatherData(data);
          setIsLoading(false);
        } catch (error) {
          console.error("weather:", error);
          setIsLoading(false);
        }
      };

      fetchWeatherData();
    }
  }, [q]);

  const updateSearch = throttle(async (inputValue: string) => {
    if (inputValue.length < 3) {
      setDestinations([]);
      return;
    }
    setIsLoadingS(true);

    try {
      const searchedTravel = (await searchTravel({ keyword: inputValue })).data;
      setDestinations(searchedTravel.destinations);
    } catch (e) {
      console.error(e);
      setInputValue(inputValue);
    } finally {
      setIsLoadingS(false);
    }
  }, 400);

  const handleInputChange = (event: React.SyntheticEvent, newInputValue: string) => {
    setInputValue(newInputValue);
    updateSearch(newInputValue);
  };

  // TODO TYPESCRIPT ERRR FIX No funtion issue
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: string | SearchContent | null,
    reason: string,
  ) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (reason === "createOption" || (newValue && newValue.isCustom)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setSelectedDestination({ name: inputValue, id: null });
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setSelectedDestination(newValue);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filterOptions = (options: any[], params: { inputValue: string }) => {
    const filtered = options.filter((option: { name: string }) =>
      option.name.toLowerCase().includes(params.inputValue.toLowerCase()),
    );

    return filtered;
  };

  const currentday = useMemo(() => {
    const current = weatherData?.forecast?.forecastday?.[0]?.day;
    return current;
  }, [weatherData]);

  const imageurl = getAbsoluteUrl(currentday?.condition?.icon);
  const hasForecast = Boolean(weatherData?.forecast);

  return (
    <Box sx={{ position: "relative", ...sx }}>
      <Box
        sx={{
          width: "100%",
          maxWidth: "350px",
          bgcolor: "#fff",
          borderRadius: "20px",
          boxShadow: "0px 2px 12px rgba(0,0,0,0.15)",
          border: "1px solid #fff",
          p: "14px",
          fontFamily: "'blauerNue', 'blauerNue Fallback'",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            position: "relative",
            ".MuiAutocomplete-root .MuiInput-root .MuiInput-input": {
              p: "0px !important",
            },
          }}
        >
          <Box
            sx={{ display: "flex", flexDirection: "column", width: "100%", position: "relative" }}
          >
            <Autocomplete
              id="destination-search"
              options={destinations}
              loading={isLoadingS}
              onInputChange={handleInputChange}
              onChange={(event, newValue, reason) => {
                if (reason === "createOption") {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  handleChange(event, { name: inputValue, id: null }, reason);
                } else {
                  handleChange(event, newValue, reason);
                }
              }}
              value={selectedDestination}
              inputValue={inputValue}
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              getOptionLabel={(option) => option.name || ""}
              filterOptions={(options, params) => {
                const filtered = filterOptions(options, params);
                if (params.inputValue !== "") {
                  filtered.push({
                    id: null,
                    name: `Add "${params.inputValue}"`,
                    isCustom: true,
                  });
                }

                return filtered;
              }}
              freeSolo
              sx={{ maxHeight: "40px", fontFamily: "'blauerNue', 'blauerNue Fallback'" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        fontFamily: "'blauerNue', 'blauerNue Fallback'",
                        fontSize: "18px",
                        fontWeight: 500,
                        color: "#E30053",
                      }}
                    >
                      Search Weather at
                    </Box>
                  }
                  variant="standard"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {isLoadingS ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                  sx={{
                    ".MuiInputBase-input.MuiInput-input.MuiAutocomplete-input": {
                      fontFamily: "'blauerNue', 'blauerNue Fallback'",
                      color: "#060273",
                      fontWeight: 600,
                      fontSize: "17px",
                    },
                    ".MuiInputBase-root.MuiInput-root.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot":
                      {
                        pr: "40px",
                      },
                    ".MuiAutocomplete-endAdornment": {
                      right: "40px",
                      top: "10px",
                    },
                    ".MuiInputBase-input.MuiInput-input.MuiInputBase-inputAdornedEnd.MuiAutocomplete-input::after":
                      {
                        borderBottom: "1px solid #ccc",
                      },
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  <div>
                    <div style={{ fontWeight: 500 }}>{option.name}</div>
                    <div style={{ fontSize: "0.875rem", color: "#666" }}>{option.country}</div>
                  </div>
                </li>
              )}
              noOptionsText="No destinations found"
              loadingText="Loading destinations..."
            />

            <SearchIcon
              sx={{
                color: "#999",
                transform: "scale(-1) rotate(-90deg)",
                position: "absolute",
                top: "2px",
                right: "-2px",
                width: "36px",
                height: "36px",
                "&:hover": {
                  color: "#000",
                  cursor: "pointer",
                },
              }}
            />
          </Box>
        </Box>

        {/* icon */}
        {isLoading ? (
          <WeatherSkeleton />
        ) : !hasForecast ? (
          <WeatherUnavailable />
        ) : (
          <>
            <Box
              position="relative"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => {
                setForecastModalOpen(true);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  mt: "10px",
                }}
              >
                <Box
                  sx={{
                    zIndex: 2,
                    color: "#444",
                    cursor: "pointer",
                    fontSize: "13px",
                    display: "flex",
                    fontWeight: 400,
                    maxWidth: "250px",
                  }}
                >
                  {`Now at ${weatherData?.location?.name}, ${weatherData?.location?.country}`}
                </Box>

                <Box
                  sx={{
                    zIndex: 2,
                    color: "#5900FF",
                    cursor: "pointer",
                    gap: "4px",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    borderBottom: "1px solid #5900FF40",
                    width: "max-content",
                    ml: "auto",
                    "&:hover": {
                      color: "#E30053",
                    },
                  }}
                  onClick={() => {
                    setForecastModalOpen(true);
                  }}
                >
                  <Box sx={{ width: "max-content" }}>View More</Box>
                  <OpenInNewRoundedIcon sx={{ width: 16, height: 16 }} />
                </Box>
              </Box>

              <Box sx={{ mt: "4px" }}>
                <Box
                  sx={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <Box sx={{ display: "flex", gap: "10px" }}>
                    {imageurl && (
                      <Box
                        sx={{
                          img: {
                            zIndex: 1,
                            objectFit: "contain",
                            height: "60px",
                            width: "60px",
                          },
                        }}
                      >
                        <Image
                          src={imageurl}
                          alt={currentday?.condition?.text ?? "Weather condition"}
                          width={70}
                          height={70}
                          loader={({ src }) => src}
                        />
                      </Box>
                    )}

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: "35px",
                        fontWeight: 700,
                        zIndex: 2,
                        mt: "8px",
                        span: {
                          fontSize: "20px",
                          fontWeight: 600,
                          mt: "4px",
                        },
                      }}
                    >
                      <Box sx={{ fontSize: "13px", color: "#222", mb: "-4px", fontWeight: 500 }}>
                        Feels like
                      </Box>
                      <Box sx={{ display: "flex", mt: "2px" }}>
                        {currentday?.avgtempC} <span>°C</span>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      mt: "12px",
                      color: "#666",
                      cursor: "pointer",
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: 1.4,
                      b: {
                        fontWeight: 600,
                        color: "#222",
                      },
                    }}
                  >
                    <Box>
                      <b>High : </b>
                      {currentday?.maxtempC} °C
                    </Box>
                    <Box>
                      <b>Low : </b>
                      {currentday?.mintempC} °C
                    </Box>
                    <Box>
                      <b>UV Index : </b>
                      {currentday?.uv}
                    </Box>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "4px",
                    width: "100%",
                    mt: "6px",
                  }}
                >
                  <WeatherUI
                    title={"Humidity"}
                    value={`${currentday?.avghumidity || ""}`}
                    icon={<HumidityIcon />}
                    params={"%"}
                  />
                  <WeatherUI
                    title={"Visibility"}
                    value={`${currentday?.avgvisKm || ""}`}
                    icon={<VisibilityIcon />}
                    params={"km"}
                  />
                  <WeatherUI
                    title={"Wind"}
                    value={`${currentday?.maxwindKph || ""}`}
                    icon={<WindIcon />}
                    params={"km/h"}
                  />
                  <WeatherUI
                    title={"Pressure"}
                    value={`${currentday?.totalprecipMm || ""}`}
                    icon={<GaugeIcon />}
                    params={"PMm"}
                  />
                </Box>
              </Box>
            </Box>

            <Box sx={{ mt: "8px" }}>
              <Divider>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#666",
                    fontSize: "12px",
                    gap: "4px",
                    pr: "4px",
                    mt: "7px",
                    mb: "6px",
                    svg: {
                      width: "20px",
                      height: "20px",
                    },
                  }}
                >
                  Tide info
                </Box>
              </Divider>

              <TideSwiper tides={convertToTideWrappers(currentday?.tides || [])} />
            </Box>
          </>
        )}
      </Box>

      <ForcastWeather
        open={forecastModalOpen}
        onclose={() => setForecastModalOpen(false)}
        weatherData={weatherData}
      />
    </Box>
  );
};

export default WeatherComponent;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
function convertToTideWrappers(tides): TideWrapper[] {
  if (tides && tides.length > 0 && tides[0].tide) {
    return tides as TideWrapper[];
  }

  return [
    {
      tide: tides.map((t: { tideTime: string; tideHeightMt: string; tideType: string }) => ({
        tideTime: t.tideTime || "",
        tideHeightMt: t.tideHeightMt || "",

        tideType: t.tideType || "",
      })),
    },
  ];
}

interface Tide {
  tideTime: string;
  tideHeightMt: string;
  tideType: string;
}

interface TideWrapper {
  tide: Tide[];
}

const TideSwiper: React.FC<{ tides: TideWrapper[] }> = ({ tides }) => {
  return (
    <Box sx={{}}>
      <Tabs
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        id="mui_tabs"
        aria-label="scrollable auto tabs example"
        sx={{
          transitions: "all 0.5s",
          alignItems: "center",
          ".MuiTabs-root": {
            boxShadow: "0px 0px 10px 0px #06027377",
            overflow: "hidden",
            alignItems: "center",
          },
          ".MuiTabs-flexContainer": {
            borderRadius: "10px",
            gap: "9px",
            p: "0px",
            transition: "all 0.5s",
            justifyContent: "left",
            alignItems: "center",
            ".MuiButtonBase-root.MuiTab-root": {
              border: "2px solid #060273",
              textTransform: "initial",
              borderRadius: "10px",
              transitions: "all 0.5s",
              minWidth: "60px",
              fontFamily: "'blauerNue', 'blauerNue Fallback'",
              fontSize: "15px",
              p: "0px",
              "&.Mui-selected": {
                bgcolor: "#060273",
                color: "#fff",
                "&:hover": {
                  bgcolor: "#060273",
                  color: "#fff",
                },
              },
              "&:hover": {
                bgcolor: "#fff",
                color: "#060273",
              },
            },
          },
          ".MuiTabs-indicator": {
            display: "none",
          },
          ".MuiTabs-scrollButtonsHideMobile": {
            display: "flex",
          },
          ".MuiButtonBase-root.MuiTabScrollButton-root.MuiTabs-scrollButtons": {
            bgcolor: "#ded9ff",
            color: "#060273",
            border: "2px solid #060273",
            opacity: 1,
            borderRadius: "10px",
            width: "26px",
            height: "58px",
            transitions: "all 0.5s",
            svg: {
              width: "35px",
              height: "35px",
              p: "2px 0px 0px",
            },
            "&:nth-of-type(1)": {
              borderRadius: "10px 0px 0px 10px",
            },
            "&:nth-of-type(4)": {
              borderRadius: "0px 10px 10px 0px",
            },
            "&.Mui-disabled": {
              opacity: 0,
              width: "0px",
              // display: "none",
            },
            "&:hover": {
              bgcolor: "#fff",
              color: "#060273",
            },
          },
        }}
      >
        {tides.map((wrapper, i) =>
          wrapper.tide.map((tide, j) => (
            <Tab
              key={`${i}-${j}`}
              iconPosition="start"
              sx={{ display: "flex", alignItems: "center", gap: "10px" }}
              label={
                <Box
                  sx={{
                    width: "100%",
                    bgcolor: "#060273",
                    color: "#fff",
                    p: "3px 6px",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      textTransform: "capitalize",
                      svg: {
                        color:
                          tide.tideType === "HIGH"
                            ? "#ff5353"
                            : tide.tideType === "LOW"
                              ? "#52ff94"
                              : "#fff",
                        rotate:
                          tide.tideType === "HIGH"
                            ? "-45deg"
                            : tide.tideType === "LOW"
                              ? "-225deg"
                              : "0deg",
                        width: "22px",
                        height: "22px",
                      },
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <Box>
                      <ArrowIcon sx={{ rotate: "-45deg" }} />
                    </Box>
                    <Box sx={{ mt: "-4px" }}>{tide.tideType.toLowerCase()} Tides</Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      fontSize: "12px",
                      fontWeight: 300,
                      borderTop: "1px solid #fff3",
                      pt: "3px",
                      svg: {
                        width: "16px",
                        height: "16px",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <TideIcon />
                      <Box sx={{ mt: "2px" }}>{tide.tideHeightMt} m</Box>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        borderLeft: "1px solid #fff3",
                        pl: "7px",
                      }}
                    >
                      <ClockIcon />
                      <Box sx={{ mt: "2px" }}>
                        {convertToAmPm(extractDateOrTime(tide.tideTime))}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              }
            />
          )),
        )}
      </Tabs>
    </Box>
  );
};

const WeatherUI: React.FC<{
  icon: React.ReactNode;
  title: string;
  value: string;
  params: string;
}> = ({ icon, title, value, params }) => {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        alignItems: "center",
        gap: "4px",
        bgcolor: "#e5e4ff",
        color: "#060273",
        borderRadius: "10px",
        p: "5px",
        width: "100%",
      }}
    >
      <Box
        sx={{
          fontSize: "12px",
          fontWeight: 400,
          display: "flex",
          ".MuiSvgIcon-root": {
            width: "18px",
            height: "18px",
            mt: "4px",
          },
          gap: "4px",
          alignItems: "center",
        }}
      >
        {icon && <Box>{icon}</Box>}
        <Box>{title}</Box>
      </Box>
      <Box sx={{ fontSize: "14px", fontWeight: 600 }}>
        {value}{" "}
        <Box component="span" sx={{ fontSize: "13px" }}>
          {params}
        </Box>
      </Box>
    </Box>
  );
};

const WeatherSkeleton = () => {
  return (
    <Box>
      <Skeleton width={"330px"} height={"198px"} sx={{ mt: "-36px" }} />
      <Skeleton width={"330px"} height={"72px"} sx={{ mt: "-36px" }} />
    </Box>
  );
};

const WeatherUnavailable = () => {
  return (
    <Box
      sx={{
        minHeight: "230px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#666",
        fontSize: "13px",
        fontFamily: "'blauerNue', 'blauerNue Fallback'",
        p: "16px 8px",
      }}
    >
      Weather data is not available for this destination yet.
    </Box>
  );
};

const convertToAmPm = (time24: string) => {
  const [hour, minute] = time24.split(":");
  const date = new Date();
  date.setHours(parseInt(hour), parseInt(minute));
  return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
};
